import { faCertificate, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styles from './icon.module.css'

const Modifiedicon = ({ verification, hideSpan }) => {
    return (
        <div className={styles.container}>
            {!hideSpan && (verification ? 'Verified' : 'Not Verified')}
            {verification === 1 && <div className={styles.vercon}>
                <FontAwesomeIcon icon={faCertificate} className={styles.certificate} />
                <FontAwesomeIcon icon={faCheck} className={styles.check} />
            </div>}
        </div>
    )
}

export default Modifiedicon